import React from 'react';

import { BsFillArrowDownCircleFill, BsFillArrowUpCircleFill } from 'react-icons/bs'

const AccordionLayout = ({ title, children, index, activeIndex, setActiveIndex }) => {
  const handleSetIndex = (index) => (activeIndex !== index) && setActiveIndex(index);

  return (
    <>
        <div onClick={() => handleSetIndex(index)} className='flex lg:w-[70%] w-[90%]  justify-between p-2 mt-4 rounded bg-slate-300'>
            <div className='flex'>
                <div className='text-black font-bold'>{title}</div>
            </div>
            <div className="flex items-center justify-center">
                {
                (activeIndex === index) 
                ? <BsFillArrowDownCircleFill className='w-6 h-6' />
                : <BsFillArrowUpCircleFill className='w-6 h-6' />
                }
            </div>
        </div>

        {(activeIndex === index) && (
            <div className="shadow-3xl lg:w-[70%] w-[90%]  rounded-2xl shadow-cyan-500/50 p-2 mb-2 text-center">
              {children}
            </div>
        )}
    </>
  );
};

export default AccordionLayout;